export default __webpack_public_path__ + "static/media/ER2_activations_XZ.fa75beb9.png";